import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../store/auth.ts';
import { IconCloud } from '../lib/icons.tsx';

export function SignupPage() {
  const signup = useAuth((s) => s.signup);
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const mismatch = confirm.length > 0 && password !== confirm;
  const tooShort = password.length > 0 && password.length < 10;

  const submit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    if (mismatch || tooShort) return;
    setBusy(true); setError(null);
    try {
      await signup(email.trim(), password, name.trim());
    } catch (err) {
      setError(err instanceof Error ? err.message : '가입에 실패했습니다');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth">
      <form className="auth__card" onSubmit={(e) => { void submit(e); }}>
        <div className="auth__brand"><IconCloud size={26} /> 가입하기</div>

        <div className="field">
          <label htmlFor="email">이메일</label>
          <input id="email" className="input" type="email" autoComplete="username" required
            value={email} onChange={(e) => { setEmail(e.target.value); }} />
        </div>
        <div className="field">
          <label htmlFor="name">표시 이름</label>
          <input id="name" className="input" required maxLength={60}
            value={name} onChange={(e) => { setName(e.target.value); }} />
        </div>
        <div className="field">
          <label htmlFor="pw">비밀번호 (10자 이상)</label>
          <input id="pw" className={tooShort ? 'input input--error' : 'input'}
            type="password" autoComplete="new-password" required minLength={10}
            value={password} onChange={(e) => { setPassword(e.target.value); }} />
          {tooShort && <span className="error-text">10자 이상이어야 합니다</span>}
        </div>
        <div className="field">
          <label htmlFor="pw2">비밀번호 확인</label>
          <input id="pw2" className={mismatch ? 'input input--error' : 'input'}
            type="password" autoComplete="new-password" required
            value={confirm} onChange={(e) => { setConfirm(e.target.value); }} />
          {mismatch && <span className="error-text">비밀번호가 일치하지 않습니다</span>}
        </div>

        {error && <p className="error-text" role="alert">{error}</p>}

        <button className="btn btn--primary btn--block" type="submit"
          disabled={busy || mismatch || tooShort} style={{ marginTop: 8, height: 40 }}>
          {busy ? <span className="spinner" /> : '가입하기'}
        </button>

        <div className="auth__foot">
          이미 계정이 있으신가요? <Link to="/login">로그인</Link>
        </div>
      </form>
    </div>
  );
}
